export const getRequestedVersion = () => {
  if (typeof window === "undefined") return 1;
  return new URLSearchParams(window.location.search).get("v") === "2" ? 2 : 1;
};

export const versionHref = (version) => {
  if (typeof window === "undefined") return version === 2 ? "?v=2" : "?";
  const url = new URL(window.location.href);
  if (version === 2) url.searchParams.set("v", "2");
  else url.searchParams.delete("v");
  url.hash = "";
  return url.href;
};
